import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from 'react-intl';
import moment from 'moment';

//Components
import {
    Form,
    Button,
    Input,
    Select
} from "@gpstrackit/react-controls";
import CustomSelect from 'Components/Select';
import { Grid } from "@mui/material";
import { getDateRange } from 'Core/data/Helpers';

//Actions
import { sizeDashboardPanelCreateEditModal, searchEntityRequest } from 'Redux/actions'
import { getAccounts } from 'Modules/dashboard/views/.components/chart/.components/forms/createEditDeviceByStatus/redux/saga';
const CreateEditMaintenanceWarnings = (props) => {
    const { messages } = useIntl();
    const { onSubmit, handleClose } = props;
    const dispatch = useDispatch();

    const devicesByStatusForm = useRef();

    const optionsFrecuency = [
        { id: 300, name: messages['dashboard_gadget_five_minutes'] },
        { id: 900, name: messages['dashboard_gadget_fifteen_minutes'] },
        { id: 1800, name: messages['dashboard_gadget_thirty_minutes'] },
        { id: 3600, name: messages['dashboard_gadget_one_hour'] },
        { id: 7200, name: messages['dashboard_gadget_two_hour'] }
    ];

    const optionsTimeMetric = [
        { id: `thisweek`, name: messages['dashboard_gadget_thisweek'] },
        { id: `lastweek`, name: messages['dashboard_gadget_lastweek'] },
        { id: `thismonth`, name: messages['dashboard_gadget_this_month'] },
        { id: `lastmonth`, name: messages['dashboard_gadget_last_month'] },
        { id: `thisyear`, name: messages['dashboard_gadget_this_year'] },
        { id: `last7days`, name: messages['dashboard_gadget_last7days'] },
        { id: `last15days`, name: messages['dashboard_gadget_last15days'] },
        { id: `last30days`, name: messages['dashboard_gadget_last30days'] },
    ]

    const {
        loadingCreateEdit,
        gadGet
    } = useSelector((state) => state.dashboardPanelMainRedux);

    const {
        dealers,
        dealersLoading,
        manufacturers,
        deviceModels,
        deviceModelsLoading,
        manufacturersLoading
    } = useSelector(state => state.generalRedux);
    const tags = useSelector(state => state.generalRedux.tags);
    const loadingTags = useSelector(state => state.generalRedux.loadingEntity);

    const [formData, setFormData] = useState({});

    const validateData = () => {
        onSubmit({
            ...formData,
            name: formData?.name,
            dealerId: formData?.dealer?.id,
            deviceModelId: formData?.deviceModel?.id,
            manufacturerId: formData?.manufacturer?.id,
            refreshSeconds: formData.refreshSeconds.id,
            accountId: formData?.account?.id,
            chartType: 'column',
            type: 'MaintenanceWarnings'
        })
    }

    const getAccountsForSelect = (input, callback) => {
        let dealerId = formData?.dealer?.id
        if (!input) {
            callback([])
            return
        }
        getAccounts(input, dealerId).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    useEffect(() => {
        if (gadGet.hasOwnProperty('name')) {
            let settings = JSON.parse(gadGet.settings);
            setFormData({
                name: settings.name,
                refreshSeconds: optionsFrecuency.filter(frecuency => frecuency.id === gadGet.refreshSeconds)[0],
                dealer: settings?.dealer,
                manufacturer: settings?.manufacturer,
                deviceModel: settings?.deviceModel,
                account: settings?.account,
                timeMetric: settings?.timeMetric,
                tagIds: settings?.tagIds || []
            })
        }
    }, [])

    useEffect(() => {
        dealers?.length === 0 && dispatch(searchEntityRequest({ key: "dealers" }))
        manufacturers?.length === 0 && dispatch(searchEntityRequest({ key: "manufacturers" }));
        deviceModels?.length === 0 && dispatch(searchEntityRequest({ key: "deviceModels" }));
        dispatch(searchEntityRequest({ key: "tags" }));
    }, [])

    return (
        <div style={{ padding: '15px 10px 20px 10px', marginBottom: 100 }}>
            <Form ref={devicesByStatusForm} onValidSubmit={validateData}>
                <div>
                    <Input
                        id="lastreading-title"
                        value={formData?.name || ''}
                        onChange={(value) => setFormData({ ...formData, name: value })}
                        minLength={1}
                        maxLength={40}
                        label={messages['dashboard_gadget_title']}
                        placeholder={messages['dashboard_gadget_title']}
                        type="text"
                        required
                        requiredMessage={messages['required_field']}
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <Select
                        id="lastreading-refresh"
                        label={messages['dashboard_gadget_frequency_refresh']}
                        placeholder={messages['dashboard_gadget_frequency_refresh']}
                        options={optionsFrecuency}
                        textField="name"
                        valueField="id"
                        value={formData.refreshSeconds}
                        onChange={(value) => setFormData({ ...formData, refreshSeconds: value })}
                        isClearable
                        required
                        requiredMessage={messages['required_field']}
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <Select
                        id="timeMetric"
                        label={messages['dashboard_gadget_time_metric']}
                        placeholder={messages['dashboard_gadget_time_metric']}
                        options={optionsTimeMetric}
                        textField="name"
                        valueField="id"
                        value={formData.timeMetric}
                        onChange={(value) => {
                            setFormData({ ...formData, timeMetric: value });
                        }}
                        isClearable
                        required
                        requiredMessage={messages['required_field']}
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <Select
                        id="lastreading-dealer"
                        label={messages['create_edit_package_brand']}
                        placeholder={messages['create_edit_package_brand']}
                        options={dealers || []}
                        valueField="id"
                        textField="name"
                        value={formData?.dealer}
                        onChange={(value) => setFormData({ ...formData, dealer: value, account: null })}
                        requiredMessage={messages['required_field']}
                        disabled={dealersLoading}
                        isClearable
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <CustomSelect
                        async
                        value={formData.account}
                        onChange={(item) => {
                            setFormData({ ...formData, account: item })
                        }}
                        label={messages['devices_import_account']}
                        placeholder={messages["devices_import_account"]}
                        loadOptions={getAccountsForSelect}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e.id}
                        isClearable
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <Select
                        id="lastreading-manufacturer"
                        label={messages['devices_main_manufacturer']}
                        value={formData?.manufacturer}
                        onChange={(value) => setFormData({ ...formData, manufacturer: value, deviceModel: null })}
                        options={manufacturers || []}
                        textField="name"
                        valueField="id"
                        menuPlacement="auto"
                        isClearable
                        loading={manufacturersLoading}
                        placeholder={messages['devices_main_manufacturer']}
                    />
                </div>
                <div style={{ marginTop: 10 }}>
                    <Select
                        id="lastreading-device-model"
                        label={messages['devices_main_device_model']}
                        value={formData?.deviceModel}
                        onChange={(value) => setFormData({ ...formData, deviceModel: value })}
                        options={formData?.manufacturer ? deviceModels && deviceModels.filter(x => x.manufacturerId === +formData?.manufacturer.id) : []}
                        textField="name"
                        valueField="id"
                        menuPlacement="auto"
                        isClearable
                        loading={deviceModelsLoading}
                        placeholder={messages['devices_main_device_model']}
                    />
                </div>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10, marginBottom: 5 }}>
                    <Select
                        id="tags-selector"
                        label={messages['accounts_main_tags']}
                        value={formData?.tagIds?.length ? tags.filter((item) => formData?.tagIds.find(x => x === item.id)) : []}
                        onChange={(item = []) => {
                            setFormData({ ...formData, tagIds: item?.map(x => x.id) || []})
                        }}
                        options={tags}
                        textField="label"
                        valueField="id"
                        loading={loadingTags}
                        isClearable
                        placeholder={messages['select']}
                        multiple
                        menuPlacement='top'
                    />
                </Grid>
            </Form>
            <div className="create-edit-buttons" style={{ width: '100%', backgroundColor: '#fff' }}>
                <Button
                    disabled={loadingCreateEdit}
                    className="btn-cancel"
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        dispatch(sizeDashboardPanelCreateEditModal('small'));
                        handleClose();
                    }}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    disabled={loadingCreateEdit}
                    onClick={(e) => devicesByStatusForm.current.submit()}
                    className="btn-dark-blue"
                >
                    {messages['save']}
                </Button>
            </div>
        </div>
    )
}

export default CreateEditMaintenanceWarnings